import type { ReactNode } from 'react';
import { cn } from '@/shared/cn';
import {
  AUTH_FIBER_GRAIN,
  AUTH_FIBER_LINES,
  AUTH_FIBER_PAGE,
  AUTH_FIBER_WARM,
} from '@/shared/ui-class';

export function FiberPaperBackdrop() {
  return (
    <div aria-hidden tabIndex={-1} className="pointer-events-none absolute inset-0 -z-10">
      <div className={cn('absolute inset-0', AUTH_FIBER_WARM)} />
      <div className={cn('absolute inset-0 opacity-[0.28] dark:opacity-[0.16]', AUTH_FIBER_LINES)} />
      <div className={cn('absolute inset-0 opacity-[0.03] dark:opacity-[0.028]', AUTH_FIBER_GRAIN)} />
    </div>
  );
}

/** Two-column flip for the auth surfaces — shared by AuthScene and the
 *  AuthSplitShell consumers (signup, lobby, declined). Hero hides < 768px. */
export const AUTH_SCENE_GRID_CSS = `
  .auth-scene-grid { grid-template-columns: minmax(0, 1fr); }
  .auth-hero { display: none; }
  @media (min-width: 768px) {
    .auth-scene-grid {
      grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
    }
    .auth-hero { display: flex; }
  }
`;

export function AuthSplitShell({
  hero,
  children,
}: {
  hero: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className={cn('relative w-full overflow-hidden', AUTH_FIBER_PAGE)}>
      <FiberPaperBackdrop />
      <div className="auth-scene-grid relative z-[1] grid min-h-screen w-full">
        {hero}
        <section className="flex items-center justify-center px-6 py-12 sm:px-10">
          {children}
        </section>
      </div>
      <style>{AUTH_SCENE_GRID_CSS}</style>
    </div>
  );
}
